import type { Chat } from '@mint-sdk/api-ai-assistant';

import { AiChart, DataTable } from '../../components/index.js';
import { SystemErrorBlock, TextBlock } from './blocks/index.js';

const MessageContent = ({
  chatId,
  messageId,
  isFullscreen,
  date,
  isSystemError,
  graph,
  text,
  dataframe,
  type = 'agentic',
  contentVisible = true,
}: {
  chatId: string;
  messageId: string;
  date: string;
  isFullscreen: boolean;
  isSystemError?: boolean;
  dataframe?: Chat.DataframeType;
  graph?: Chat.Graph;
  text: string;
  type: 'mobile' | 'agentic' | 'desktop';
  contentVisible?: boolean;
}) => {
  const shouldDisplayCharts =
    contentVisible && graph && Object.keys(graph).length && graph.instructions;

  const isVisibleDataTable =
    contentVisible && (dataframe?.length ?? 0) > 0 && Array.isArray(dataframe);

  if (isSystemError) return <SystemErrorBlock />;

  return (
    <>
      <TextBlock text={text} isMobile={type === 'mobile'} />

      {isVisibleDataTable && (
        <DataTable
          dataframeData={dataframe}
          chatId={chatId}
          messageId={String(messageId)}
          type={type}
        />
      )}

      {shouldDisplayCharts && (
        <AiChart
          isAgentic={isFullscreen}
          dataframe={dataframe}
          graph={graph}
          date={date}
        />
      )}
    </>
  );
};

export { MessageContent };
